import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinnerThird } from '@fortawesome/pro-solid-svg-icons/faSpinnerThird';
import visuallyHidden from '../../../styles/visuallyHidden.ts';
import { SIZES, COLORS, ALIGN } from '../../../constants/theme.ts';
import styles from './Loader.scss';

const Loader = ({
    classes, color, size, align, isDrawerLoader,
}) => (
    <div
        role="status"
        className={classNames(styles.outerContainer, {
            [styles.container]: isDrawerLoader,
            [styles.drawerLoaderContainer]: isDrawerLoader,
            [classes.root]: isDrawerLoader,
            [styles[align]]: isDrawerLoader,
        })}
    >
        <span style={visuallyHidden}>Loading…</span>
        <div
            className={
                classNames(!isDrawerLoader ? styles.container : '', styles.loaderContainer, classes.root, styles[color], styles[align], styles[size])
            }
        >
            <FontAwesomeIcon
                className={styles.loadingIcon}
                icon={faSpinnerThird}
                spin
            />
        </div>
    </div>
);

Loader.propTypes = {
    classes: PropTypes.shape({
        root: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.string]),
    }),
    color: PropTypes.oneOf(Object.values(COLORS)),
    size: PropTypes.oneOf(Object.values(SIZES)),
    align: PropTypes.oneOf(Object.values(ALIGN)),
    isDrawerLoader: PropTypes.bool,
};

Loader.defaultProps = {
    classes: {
        root: null,
    },
    color: COLORS.default,
    size: SIZES.medium,
    align: ALIGN.center,
    isDrawerLoader: false,
};

export default Loader;
